import { createUseStyles } from 'react-jss';

import { hideScrollbars, ITheme, mozScrollbars, scrollbars } from '../../../styles';

const useStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    root: {
      border: `2px solid ${colors.borderColor}`,
      borderRadius: 8,
      overflowX: 'hidden',
      overflowY: 'auto',
      scrollBehavior: 'unset',

      ...hideScrollbars,
      ...scrollbars(),
      ...mozScrollbars(),
    },
  }),
  { name: 'file-list' },
);

export default useStyles;
